export const useDashboardEventStyle = event => {
    const className = event.type === 'prototype'
                        ? 'prototype-case' : event.type === 'temp'
                            ? 'temp-case' : event.type === 'other'
                                ? 'other-case' : event.type === 'ceramic'
                                    ? 'ceramic-case' : 'zirconia-case' + ' case-type';
    return { className };
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/CustomHooks/useDashboardEventStyle.js